<div class="theme-layout" id="scrollup">
    <div class="wrapper-naps-home">
        <section class="header-wrapper">
            <div class="header-content" id="headerContent">

                <nav id="desktop-nav" class="">
                    <div [class.visibility-hidden]="hideElement || !showMarquee" class="nofify">
                        <div class="microsoft marquee">

                            <span class="">
                                <ng-container *ngFor="let cast of casting;index as i">
                                    <ng-container *ngIf="cast.popup=='true'; else noPopUp">
                                        <a class="d-inline-block" (click)="openPopUp(content,cast,i)"
                                            *ngIf="cast.popup=='true'"
                                            [innerHTML]="cast.content.rendered | safeHtml: 'html'">

                                        </a>
                                    </ng-container>
                                    <ng-template #noPopUp>
                                        <ng-container *ngIf="cast.landing_page_url;else noLinkNotify">
                                            <ng-container
                                                *ngIf="cast.landing_page_url.endsWith('.pdf') || cast.landing_page_url.endsWith('.PDF'); else notPdfLink">
                                                <a [ngStyle]="{'text-decoration': cast.landing_page_url?'underline':'none'}"
                                                    class="d-inline-block " *ngIf="cast.popup=='false'"
                                                    (click)="downloadpdf(cast.landing_page_url)"
                                                    [innerHTML]="cast.content.rendered | safeHtml: 'html'">
                                                </a>
                                            </ng-container>
                                            <ng-template #notPdfLink>
                                                <a [ngStyle]="{'text-decoration': cast.landing_page_url?'underline':'none'}"
                                                    class="d-inline-block " *ngIf="cast.popup=='false'" target="_blank"
                                                    href="{{cast.landing_page_url?cast.landing_page_url:''}}"
                                                    [innerHTML]="cast.content.rendered | safeHtml: 'html'">
                                                </a>
                                            </ng-template>
                                        </ng-container>
                                        <ng-template #noLinkNotify>
                                            <a *ngIf="cast.id != '123456'"
                                                [ngStyle]="{'text-decoration': cast.landing_page_url?'underline':'none'}"
                                                class="d-inline-block"
                                                [innerHTML]="cast.content.rendered | safeHtml: 'html'">
                                            </a>
                                            <a *ngIf="cast.id == '123456'" (click)="getSchedule()"
                                                [ngStyle]="{'text-decoration': cast.landing_page_url?'underline':'none'}"
                                                class="d-inline-block"
                                                [innerHTML]="cast.content.rendered | safeHtml: 'html'"></a>
                                        </ng-template>
                                    </ng-template>
                                </ng-container>
                            </span>
                        </div>
                    </div>
                    @if(isSmallWindow()){
                        <li [class.visibility-hidden]="showSearchBoxInMobileView()" class="btns-profiles-sec" id="mobile-view-user-icon" *ngIf="decode">
                            <span>
                                <img *ngIf="!fileDataProfImg" src="assets/images/default_user.jpg" />
                                <img *ngIf="fileDataProfImg" src="{{fileDataProfImg}}" />
                                {{name | slice:0:25}}
                                <i class="la la-angle-down"></i>
                            </span>
                            <ul>
                        
                                <li *ngIf="registerNumber">
                                    <a style="cursor:initial"><i class="la la-info"></i><strong>{{registerNumber}}</strong></a>
                                </li>
                        
                                <li><a (click)="goToProfile()" title=""><i class="la la-tachometer"></i> Dashboard</a></li>
                                <li><a *ngIf="candidateIs" (click)="goTocandidateProfile()" title=""><i class="la la-user"></i>
                                        Profile</a></li>
                        
                                <!-- <li><a *ngIf="candidateIs" (click)="changepassword()" title=""><i class="la la-key"></i> Change
                                        Password</a></li> -->
                                <li><a title="" (click)="logOut()"><i class="la la-sign-out"></i>
                                        Logout</a></li>
                            </ul>
                        </li>
                        }
                    <div class="container-fluid main-menu">
                        <div class="d-flex navbar navbar-expand-lg navbar-light  align-items-end justify-content-start p-0 ">
                            <div class="btn-extars">
                                <div>
                                    <div class="menu-header mx-mobile-16 d-flex align-items-center justify-content-between justify-content-lg-around "
                                        [class.search-box-open]="showSearchBoxInMobileView()">
                                        @if(showSearchBoxInMobileView() && !location.path().includes('apprenticeship/opportunity')){
                                        <ng-container *ngTemplateOutlet="searchBox"></ng-container>
                                        }
                                        @else(){
                                        <div class="logo-group">
                                            <img src="./assets/images/skill-india.png" alt="Skill India Logo"
                                                routerLink="/" class="menu-logo" style="cursor: pointer;">
                                            <div class="mid-line"></div>
                                            <img src="./assets/images/msde.png" alt="Ministry Logo" routerLink="/" class="menu-logo" style="cursor: pointer;">
                                            <div class="mid-line"></div>
                                            <img src="./assets/images/naps_logo_final.png" alt="NAPS Logo"
                                                routerLink="/" class="menu-logo" style="cursor: pointer;">
                                        </div>
                                        <div class="mobile-icons d-flex justify-content-center align-items-center">
                                            <div class="header-right-side">
                                                <ul class="account-btns menu-sec-log" [class.naps-search-logo]="isSmallWindow()" >
                                                    @if(isSmallWindow() && !location.path().includes('apprenticeship/opportunity')){
                                                    <li>
                                                        <button aria-label="Toggle searchBox" class="search-mobile-icon"
                                                            (click)="showSearchBoxInMobileView.set(true)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20"
                                                                height="20" viewBox="0 0 20 20" fill="none">
                                                                <path
                                                                    d="M19 19L14.65 14.65M9 4C11.7614 4 14 6.23858 14 9M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
                                                                    stroke="black" stroke-width="1.5"
                                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </button>
                                                    </li>
                                                    }@else{
                                                    <div class="search-box-open">
                                                        <ng-container *ngTemplateOutlet="searchBox"></ng-container>
                                                    </div>

                                                    }
                                                    @if(!isSmallWindow()){
                                                    <li *ngIf="!decode">
                                                        <app-naps-button [isOpenNewTab]="true"
                                                            [buttonName]="buttons.dashBoard" (clicked)="melaPage()">
                                                            <span class="dasboard-span">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="22"
                                                                    height="22" viewBox="0 0 22 22" fill="none">
                                                                    <path
                                                                        d="M20.2104 14.8901C19.5742 16.3946 18.5792 17.7203 17.3123 18.7514C16.0454 19.7825 14.5452 20.4875 12.9428 20.8048C11.3405 21.1222 9.68483 21.0422 8.12055 20.5719C6.55627 20.1015 5.13103 19.2551 3.96942 18.1067C2.80782 16.9583 1.94522 15.5428 1.45704 13.984C0.968859 12.4252 0.869965 10.7706 1.169 9.1647C1.46804 7.55885 2.1559 6.0507 3.17245 4.7721C4.189 3.4935 5.50329 2.48339 7.0004 1.83007M20.2392 7.17323C20.6395 8.1397 20.8851 9.16143 20.9684 10.2009C20.989 10.4577 20.9993 10.5861 20.9483 10.7018C20.9057 10.7984 20.8213 10.8898 20.7284 10.94C20.6172 11.0001 20.4783 11.0001 20.2004 11.0001H11.8004C11.5204 11.0001 11.3804 11.0001 11.2734 10.9456C11.1793 10.8976 11.1028 10.8211 11.0549 10.7271C11.0004 10.6201 11.0004 10.4801 11.0004 10.2001V1.80007C11.0004 1.5222 11.0004 1.38327 11.0605 1.27205C11.1107 1.17915 11.2021 1.09476 11.2987 1.05216C11.4144 1.00117 11.5428 1.01146 11.7996 1.03205C12.839 1.11539 13.8608 1.36095 14.8272 1.76127C16.0405 2.26382 17.1429 3.00042 18.0715 3.929C19.0001 4.85759 19.7367 5.95998 20.2392 7.17323Z"
                                                                        stroke="#EA651F" stroke-width="1.5"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                                {{buttons.dashBoard.name}}
                                                            </span>

                                                        </app-naps-button>
                                                    </li>
                                                    <li *ngIf="!decode">
                                                        <app-naps-button [isbuttonWithTag]="true"
                                                            [tag_Button_Name]="buttons.mela"
                                                            (clicked)="melaPage()"></app-naps-button>
                                                    </li>

                                                    <li class="" *ngIf="!decode">
                                                        <app-naps-button [isDropDownButton]="true"
                                                            [buttonName]="buttons.login.key"
                                                            [dropDownData]="buttons.login.dropDown">
                                                            <span>
                                                                {{buttons.login.key.name}}&nbsp;
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14"
                                                                    height="8" viewBox="0 0 14 8" fill="none"
                                                                    class="ml-2">
                                                                    <path d="M1 1L7 7L13 1" stroke="#FFFFFF"
                                                                        stroke-width="1.5" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                            </span>
                                                        </app-naps-button>
                                                    </li>
                                                    <li class="btns-profiles-sec" *ngIf="decode">
                                                        <span style="color:slategray">
                                                            <img *ngIf="!fileDataProfImg"
                                                                src="assets/images/default_user.jpg" />
                                                            <img *ngIf="fileDataProfImg" src="{{fileDataProfImg}}" />
                                                            {{name | slice:0:25}}
                                                            <i class="la la-angle-down"></i></span>
                                                        <ul>

                                                            <li *ngIf="registerNumber">
                                                                <a style="cursor:initial"><i
                                                                        class="la la-info"></i><strong>{{registerNumber}}</strong></a>
                                                            </li>

                                                            <li><a (click)="goToProfile()" title=""><i
                                                                        class="la la-tachometer"></i> Dashboard</a></li>
                                                            <li><a *ngIf="candidateIs" (click)="goTocandidateProfile()"
                                                                    title=""><i class="la la-user"></i>
                                                                    Profile</a></li>

                                                            <!-- <li><a *ngIf="candidateIs" (click)="changepassword()"
                                                                    title=""><i class="la la-key"></i> Change
                                                                    Password</a></li> -->
                                                            <li><a title="" (click)="logOut()"><i
                                                                        class="la la-sign-out"></i>
                                                                    Logout</a></li>
                                                        </ul>
                                                    </li>
                                                    }
                                                </ul>
                                            </div>
                                            <button type="button" class="btn-bar-icon" (click)="onMenuIcon()"
                                                aria-label="Toggle navigation">
                                                @if(isHamburgerOpen()){
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                        <path d="M10.5 1.5L1.5 10.5M1.5 1.5L10.5 10.5" stroke="#2442C8" stroke-width="1.5" stroke-linecap="round"/>
                                                      </svg>
                                                }
                                                @else{
                                                    <i class="sd sd-menu-01" ></i>
                                                }
                                            </button>
                                        </div>
                                        }
                                    </div>

                                  <!-- Mobile view (nav icon toggled) -->
                                  <div *ngIf="!isSmallWindow()" class="mobile-header-bottom" >
                                    <div class="header-bottom p-0">
                                      <ul class="accounts-btns menu-sec-log">
                                        <li class="nav-item dropdown" *ngFor="let menu of menuData.mainMenu; let i = index">
                                          @if (menu.hasSubMenu) {
                                          <a #dropdownToggle 
                                            class="nav-link dropdown-toggle p-0 d-flex align-items-center "
                                            id="navbarDropdownMenuLink"
                                            role="button"
                                            data-toggle="dropdown"
                                            (mouseenter)="openMenu(i)"
                                            (mouseover)="openMenu(i)"
                                            aria-haspopup="true"
                                            [attr.aria-expanded]="menuOpenIndex() == i"
                                          >
                                            {{ menu.name }}
                                            <span class="icon-align" >
                                                @if(menuOpenIndex() == i){
                                                    <svg class="ml-2 align-middle" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                                                        <path d="M13 7L7 1L1 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                      </svg>
                                                }@else{
                                                    <svg class="ml-2 align-middle" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                                                        <path d="M1 1L7 7L13 1" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                      </svg>
                                                }
                                            </span>
                                          </a>
                                          } @else {
                                          @if (menu.isRoutable) {
                                          <a id="navbarDropdownMenuLink" class="nav-link p-0 d-flex align-items-center" role="button" [routerLink]="menu.url">{{ menu.name }}</a>
                                          } @else if (menu.isdownload) {
                                          <a id="navbarDropdownMenuLink" class="nav-link p-0 d-flex align-items-center" role="button" (click)="downloadpdf(menu.url)">{{ menu.name }}</a>
                                          } @else if (menu.doNothing) {
                                            <a id="navbarDropdownMenuLink" class="nav-link p-0 d-flex align-items-center" role="button">{{ menu.name }}</a>
                                            } @else {
                                          <a id="navbarDropdownMenuLink" class="nav-link p-0 d-flex align-items-center" [href]="menu.url" target="_blank">{{ menu.name }}</a>
                                          }
                                          }
                                          <!-- First Level Dropdown -->
                                          <ul #dropdownMenu id="naps-dropdown-menu" class="dropdown-menu p-3" [class.show]=" menuOpenIndex() == i" *ngIf="menu.hasSubMenu" aria-labelledby="navbarDropdownMenuLink" [ngClass]="i==0 ? 'scrollable-dropdown': ''">
                                            <li *ngFor="let sub of menu.subMenu" class="dropdown-submenu position-relative">
                                            <ng-container *ngIf="sub.hasNextedMenu; else simpleLink">
                                                <a #submenuToggle class="dropdown-item dropdown-toggle d-flex justify-content-between" role="button">
                                                    {{ sub.name }}
                                                    <span class="dropdown-toggle-icon">
                                                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M1 13L7 7L1 1" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                        </svg>
                                                    </span>
                                                </a>
                                                <div class="dropdown-submenu-buffer"></div> <!-- Invisible to keep submenu open this will behave like an island connecter between them buffer -->
                                                <!-- Second Level Dropdown -->
                                                <ul class="dropdown-menu p-3 submenu-right scrollable-dropdown" #submenuMenu>
                                                    <li *ngFor="let next of sub.nextedMenu">
                                                        @if(next.hasNestedSubMenu){
                                                            @if(next.isVideoOnTitle){
                                                                <a class="dropdown-item title-of-nexted-menu" [href]="next.url" target="_blank"> <img src="../../../assets/images/new_icons/lang.png" alt="lang-icon"> {{ next.name }}</a>
                                                            }@else{
                                                                <a class="dropdown-item title-of-nexted-menu"> <img src="../../../assets/images/new_icons/lang.png" alt="lang-icon"> {{ next.name }}</a>
                                                            }
                                                            @for( nest of next.nestedSubMenu ; track nest){
                                                                @if (nest.isdownload) {
                                                                    <a class="dropdown-item inner-menu" (click)="downloadpdf(nest.url)">{{ nest.name }}</a>
                                                                    } @else if (nest.isRoutable) {
                                                                    <a class="dropdown-item inner-menu" [routerLink]="nest.url">{{ nest.name }}</a>
                                                                    }@else if (nest.doNothing) {
                                                                    <a class="dropdown-item inner-menu">{{ nest.name }}</a>
                                                                    } @else {
                                                                    <a class="dropdown-item inner-menu" [href]="nest.url" target="_blank">{{ nest.name }}</a>
                                                                    }
                                                            }
                                                                <div class="gradient-hr"></div>
                                                        }@else{
                                                            @if (next.isdownload) {
                                                                <a class="dropdown-item  " (click)="downloadpdf(next.url)">{{ next.name }}</a>
                                                                } @else if (next.isRoutable) {
                                                                <a class="dropdown-item" [routerLink]="next.url">{{ next.name }}</a>
                                                                }@else if (next.doNothing) {
                                                                <a class="dropdown-item ">{{ next.name }}</a>
                                                                } @else {
                                                                <a class="dropdown-item " [href]="next.url" target="_blank">{{ next.name }}</a>
                                                                }
                                                        }
                                                       
                                                    </li>
                                                    
                                                </ul>
                                            </ng-container>
                                  
                                              <!-- Second Level Non-Nested -->
                                            <ng-template #simpleLink>
                                                @if (sub.isdownload) {
                                                <a class="dropdown-item" (click)="downloadpdf(sub.url)">{{ sub.name }}</a>
                                                } @else if (sub.isRoutable) {
                                                <a class="dropdown-item" [routerLink]="sub.url">{{ sub.name }}</a>
                                                }@else if (sub.doNothing) {
                                                <a class="dropdown-item">{{ sub.name }}</a>
                                                } @else {
                                                <a class="dropdown-item" [href]="sub.url" target="_blank">{{ sub.name }}</a>
                                                }
                                            </ng-template>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                      
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </section>
    </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-wrapper">
        <div class="modal-header" id="advisory">
            <h5 [innerHTML]="popUpTitle|safeHtml: 'html'" class="modal-title" id="modal-basic-title">
            </h5>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" id="advisory-body" *ngIf="popUpContent">
            <div [innerHTML]="popUpContent|safeHtml: 'html'" id="modal-bind-content">

            </div>
        </div>
    </div>
</ng-template>


<ng-template #report let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Apprenticeship Reports</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-xl-12">
                <div class="m-form_section m-form_section--first">
                    <span>Apprenticeship reports are enabled for Administrator and Approving Authority roles
                        only.</span>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        &nbsp;&nbsp;
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cancel</button>
        &nbsp;&nbsp;
        <a target="_blank" href="https://reports.nsdcindia.org/NanoClientApplication/Welcome"
            (click)="modal.close('Close click')">
            <button class="view-oppo btn btn-outline-primary">
                <span>
                    <i class="la la-draft"></i>
                    <span>Proceed</span>
                </span>
            </button>
        </a>
    </div>
</ng-template>

<ng-template #searchBox>
    @if(!location.path().includes('apprenticeship/opportunity')){
    <li [class.w-100]="showSearchBoxInMobileView()" class="pr-2 pr-md-0">
        <form [formGroup]="candidateJobSearchForm">
            <div class="dropdown-container">
                <div class="dropdown-field1">
                    <div class="icon-dropdown-wrapper">
                        @if(showSearchBoxInMobileView()){
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M19 19L14.65 14.65M9 4C11.7614 4 14 6.23858 14 9M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        }@else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M19 19L15.5001 15.5M18 9.5C18 14.1944 14.1944 18 9.5 18C4.80558 18 1 14.1944 1 9.5C1 4.80558 4.80558 1 9.5 1C14.1944 1 18 4.80558 18 9.5Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        }
                        <ng-select id="naps-header-searchBar" class="custom" #searchSelect dropdownPosition=bottom
                            [class.searchenable]="searchdModify" placeholder="Keyword" bindLabel="keyword"
                            bindValue="keyword" (blur)="updateSerachField($event)" (focus)="updateSerachFields($event)"
                            (change)="updateSearch($event)" (close)="updateSearchClose($event)" [clearable]=false
                            [addTagText]="''" formControlName="name" [items]="opportunites | async"
                            (keyup.enter)="submitSearch()" [multiple]="false" [hideSelected]="true"
                            placeholder="Search Opportunities" [loading]="loadingOpportunities" [addTag]="true"
                            [typeahead]="opportunityInput">
                        </ng-select>
                        @if(showSearchBoxInMobileView()){
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"
                            (click)="showSearchBoxInMobileView.set(false)">
                            <path d="M11 1L1 11M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        }
                    </div>
                </div>
            </div>
        </form>
    </li>
}
</ng-template>